'use client'

import { useState, useEffect } from 'react'
import { readCookieConsent, writeCookieConsent } from '@/lib/cookie-consent-storage'

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Check if user has already accepted cookies. Never throws when the
    // browser blocks storage (#910): that reads as "no choice yet".
    const consent = readCookieConsent()
    if (!consent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => {
        setShowBanner(true)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  const acceptCookies = () => {
    writeCookieConsent('accepted')
    setShowBanner(false)
  }

  const declineCookies = () => {
    writeCookieConsent('declined')
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-2xl z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-lg mb-2">🍪 We use cookies</h3>
            <p className="text-sm text-gray-300">
              We use cookies to enhance your experience, analyze site usage, and remember your preferences. 
              By clicking "Accept", you consent to our use of cookies in accordance with our{' '}
              <a href="/privacy" className="underline hover:text-white transition-colors">
                Privacy Policy
              </a>
              {' '}and POPIA/GDPR compliance.
            </p>
          </div>
          <div className="flex gap-3 shrink-0">
            <button
              onClick={declineCookies}
              className="px-6 py-2 border-2 border-white/30 hover:border-white/50 rounded-lg font-semibold whitespace-nowrap transition-colors"
            >
              Decline
            </button>
            <button
              onClick={acceptCookies}
              className="px-6 py-2 bg-primary-600 hover:bg-primary-700 rounded-lg font-semibold whitespace-nowrap transition-colors"
            >
              Accept Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
